
define('text!TescoMobile_ClubCard/template/is-clubcard.html',[],function () { return '<input type="hidden" name="is_clubcard" value="0">';});

